class ContactRequestDTO {
	constructor({ id, fullName, nationality, postalCode, street, number, complement, city, state, country, percent, role, email, linkedin, cpf, rg, birthday, phone, url, documentOrder }) {
        this.id = id;
        this.fullName = fullName;
        this.nationality = nationality;
		this.postalCode = postalCode;
		this.street = street;
		this.number = number;
		this.complement = complement;
		this.city = city;
		this.state = state;
		this.country = country;
        this.percent = percent;
        this.role = role;
        this.email = email;
        this.linkedin = linkedin;
        this.cpf = cpf;
        this.rg = "";
        this.birthday = birthday;
        this.phone = phone;
        this.url = url;
        this.documentOrder = documentOrder;
	}
}

export default ContactRequestDTO;